module.exports = __webpack_public_path__ + "static/media/la.b61549ab.svg";